import { ReactElement } from 'react';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { Translate } from '@dreryk/react-common';

import { FormSectionHeader } from '../../common/FormSectionHeader';
import { patientConsentsAndAuthorizationsTranslationKeys } from '../../translations';

import { ConsentsAndAuthorizationsTable } from './table/ConsentsAndAuthorizationsTable';

type ConsentsAndAuthorizationsProps = {
   readonly patientId: Patient['id'];
};

export const ConsentsAndAuthorizations = (props: ConsentsAndAuthorizationsProps): ReactElement => {
   return (
      <div>
         <FormSectionHeader>
            <Translate>{patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.header}</Translate>
         </FormSectionHeader>
         <ConsentsAndAuthorizationsTable patientId={props.patientId} />
      </div>
   );
};
